export const NETWORKING_FEATURE_RELEASE_DATE = new Date(
  "2025-06-30T00:00:00Z",
).getTime();
